// extracted by mini-css-extract-plugin
module.exports = {"root":"Configuration_root__tOpAe","sidebar":"Configuration_sidebar__JcCI5","content":"Configuration_content__bp707"};